module.exports = __webpack_public_path__ + "img/yom_huledet_no.7befe601.png";